// 全局配置公共组件
import publicDialog from "./publicDialog.vue";
import publicBuy from "./publicbuy.vue";
import publicPay from "./publicpay.vue";
import publicSuccess from "./publicsuccess.vue";
import publicHeader from './publicHeader.vue'
import publicDownApp from './downApp.vue'

export default {
  install (Vue) {
    Vue.component('publicdialog', publicDialog)// 公共弹窗组件
    Vue.component('publicbuy', publicBuy) //公共购买/兑换确认组件
    Vue.component('publicpay', publicPay) //公共支付组件
    Vue.component('publicsuccess', publicSuccess) //公共支付组件
    Vue.component('publicHeader', publicHeader) //公共支付组件
    Vue.component('publicDownApp', publicDownApp) //公共支付组件
  }
}